import history from '../../../utils/history';
import { STUDY_SPEED_SETTINGS } from '../../AccountSettings/MyProfile/constants/StudySpeedSettings';

const SPEED_INFO = {
  [STUDY_SPEED_SETTINGS.ALL_NEW]: {
    name: 'Supersonic',
    description: 'Focuses on new questions',
  },
  [STUDY_SPEED_SETTINGS.MOSTLY_NEW]: {
    name: 'Intercept Speed',
    description: 'Prioritizes new questions over review',
  },
  [STUDY_SPEED_SETTINGS.DEFAULT]: {
    name: 'Cruising Speed',
    description: 'Balanced mix of new and review',
  },
  [STUDY_SPEED_SETTINGS.BALANCED]: {
    name: 'Landing Speed',
    description: 'Prioritizes review over new',
  },
  [STUDY_SPEED_SETTINGS.MOSTLY_REVIEW]: {
    name: 'Taxi Speed',
    description: 'Focuses on review and learning',
  },
};

function StudySpeedSection({ studySpeedSetting }) {
  const studySpeedName = SPEED_INFO[studySpeedSetting]?.name;
  const studySpeedDescription = SPEED_INFO[studySpeedSetting]?.description;

  return (
    studySpeedName &&
    studySpeedDescription && (
      <section className="col-lg-3 col-md-4 col-sm-12">
        <div className="d-flex flex-row justify-content-around align-items-center flex-wrap study-speed__container">
          <div className="ml-2 text-center">
            <span className="d-block font-weight-bold text-white">
              STUDY SPEED: {studySpeedName}
            </span>
            <span
              className="d-block text-white"
              style={{ fontSize: '0.75rem', opacity: 0.8 }}
            >
              {studySpeedDescription}
            </span>
          </div>
          <button
            className="btn btn-primary btn-study-speed"
            onClick={() => history.push('/app/account-settings')}
          >
            CHANGE
          </button>
        </div>
      </section>
    )
  );
}

export default StudySpeedSection;
